module.exports = __webpack_public_path__ + "static/media/salaryMoneyWallet.bdbb59a5.svg";